import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('TAX REGIMES SERVICE');

@Injectable({
  providedIn: 'root'
})
export class TaxRegimesService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'taxRegimes' como el nombre del recurso a la clase base
    super('taxRegimes');
    log.debug('Servicio de Régimen Fiscal inicializado');
  }

}
